export default __webpack_public_path__ + "static/media/fauna-docs-qs-analytics.95aabe5d.png";